import { addValidationRule } from '@akihirotakamura/formsy-react'

addValidationRule('isLng', (values, value) => {
  if (!value || value === '') return true
  return value.match(/^-?\d{1,3}(.\d{1,})?$/) && value <= 180 && value >= -180
})
